// Small instructional pill that floats at the top of the player's
// field during the blockers phase. Walks the user through the click /
// drag flow when a blocker is pending vs. nothing yet selected.

import type { Selection } from "../../logic/selection";
import type { pixelTheme } from "../../theme/pixel";
import { factionFor } from "../../theme/factions";

export function BlockHint({
  selection,
  theme,
  faction,
}: {
  selection: Selection;
  theme: typeof pixelTheme;
  faction: string;
}) {
  const f = factionFor(faction);
  const msg =
    selection.pendingBlocker !== null
      ? "Now click the enemy attacker you want to block"
      : "Click one of your creatures to start assigning a block";
  return (
    <div
      style={{
        position: "absolute",
        top: 8,
        left: "50%",
        transform: "translateX(-50%)",
        padding: "4px 12px",
        background: f.color,
        color: f.ink,
        fontFamily: theme.fontDisplay,
        fontSize: 10,
        letterSpacing: theme.letterSpacing,
        border: `2px solid ${theme.panelEdgeStrong}`,
        zIndex: 20,
      }}
    >
      {msg}
    </div>
  );
}
